import { useEffect, useState } from "react";
import { _BusinessProcess, _PlanMaintenanceItems, _RequestMaintenance, _single, _UpcomingMaintenance, _WorkMaintenanceOrder } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import useModal, { MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicTable, MASK_MONEY } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { EditorFixedAssetItemByOperationState } from "../../../../../editor/AssetItemsByOperationState/EditorFixedAssetItemByOperationState";
import { SelectMaintenanceTypeItem } from "../../../MaintenanceTypeItem/SelectMaintenanceTypeItem";
import { _FixedAssetItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { Alert } from "../../../../../theme/Component/Alert";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { EditorFixedAssetItemByFilters } from "../../../../../editor/AssetItemsByOperationState/EditorFixedAssetItemByFilters";


interface Props {
    _planMaintenanceArea: any;
}

interface formData {
    IDPlanMaintenanceArea: number;
    State: number
}

export const PlanMaintenanceItems = ({ _planMaintenanceArea }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_PlanMaintenanceItems);
    const _bProcess = useDataBean(_BusinessProcess);
    const maintenance = useDataBean(_RequestMaintenance);
    const order = useDataBean(_WorkMaintenanceOrder);
    const fixedAsset = useDataBean(_FixedAssetItem);
    const nextMaintenance = useDataBean(_UpcomingMaintenance);

    const paginador = usePaginator();

    const [request, setRequest] = useState<any>({});

    const [data, setData] = useState<Partial<formData>>({
        IDPlanMaintenanceArea: _planMaintenanceArea.IDPlanMaintenanceArea
    });
    const [info, setInfo] = useState<any>({});

    const modal = useModal(`Seleccionar Maquina`, MODAL_md);
    const modalDelete = useModal(`Eliminar programa`, MODAL_md);
    const modalStart = useModal(`Iniciar Mantenimiento`, MODAL_md);

    useEffect(() => {
        if (_planMaintenanceArea.IDPlanMaintenanceArea) {
            getData();
        }
    }, [_planMaintenanceArea.IDPlanMaintenanceArea])

    const getData = () => {
        instance.getQuantityPlanMaintenanceItemsByArea(_planMaintenanceArea.IDPlanMaintenanceArea).then(
            (resp) => {
                setInfo(resp)
                getLista();
            }
        ).catch(err => { toast.error(err) })
    }

    const getLista = () => {
        instance.getPlanMaintenanceItemsRender(paginador.page, 15, data).then(
            (resp: any) => {
                if (resp.List.length > 0) {
                    resp.List.forEach(element => {
                        const mantenimiento = element.DataBeanProperties;
                        mantenimiento.EntityMachine = mantenimiento.IDFixedAssetItem ? `${mantenimiento.FixedAssetItemCode ?? ""} - ${mantenimiento.FixedAssetDescription}` : "N/P"
                    });
                    setLista(resp.List);
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    setBean({});
                } else {
                    setLista([])
                }
            }
        ).catch(err => { toast.error(err) });
    }

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            IDPlanMaintenanceArea: _planMaintenanceArea.IDPlanMaintenanceArea,
            IDPlanMaintenance: _planMaintenanceArea.IDPlanMaintenance,
        });
        modal.open();
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updatePlanMaintenanceItems(obj)
            .then((resp: any) => {
                getData();
                modalDelete.close();
                modal.close();
            })
            .catch(err => toast.error(err));
    };

    const head = [
        { title: 'ID', property: 'IDPlanMaintenanceItems', visible: true },
        { title: 'Maquina', property: 'EntityMachine', visible: true }, ,
        { title: 'Tipo de Mantenimiento', property: 'MaintenanceName', visible: true },
        { title: 'Costo Aproximado', property: 'MaintenanceCost', visible: true, mask: MASK_MONEY },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: (_single.canCreate() && _planMaintenanceArea.PlanState === 2), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: (_single.canEdit() && _planMaintenanceArea.PlanState === 1 && bean.State == 1), evento: () => { modal.open("Editar Maquina seleccionada") } },
            { titulo: 'Iniciar Mantenimiento', icono: 'ri-folder-transfer-line', visible: (_single.canEdit() && _planMaintenanceArea.PlanState === 2 && bean.State == 1), evento: () => { modalStart.open(); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: (_single.canDelete() && _planMaintenanceArea.PlanState === 1 && bean.State == 1), evento: () => { modalDelete.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const startProcess = () => {

        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();

        const payload = JSON.stringify({
            ...bean,
            IDAccount: _single.getAccountID(),
            IDFixedAssetItem: bean.IDFixedAssetItem,
            IDFixedAssetItemName: bean.EntityMachine,
            IDEmployee: _single.getAccountID(),
            ReportDate: _single.getCurrenDate(),
            IsPlan: true,
            ReportTimeH: currentHour,
            ReportTimeM: currentMinute,
            State: 2,
            Observations: `Plan de mantenimientos`,
            IDPlanMaintenanceItems: bean.IDPlanMaintenanceItems,
        });


        _bProcess.instance.requestBusinessProcess(
            _single.getAccountID(),
            request.Obs,
            "SOLMD",
            "IDFixedAssetItem",
            bean.IDFixedAssetItem,
            payload,
            ""
        ).then((resp) => {
            toast.success(`Se ha iniciado el proceso con IDProcedureImp ${resp.AlphaCode}`);
            maintenance.instance.updateRequestMaintenance({
                IDProceudreIMP: resp.IDProcedureImp,
                AlphaCodeProcedure: resp.AlphaCode,
                IDFixedAssetItem: bean.IDFixedAssetItem,
                IDFixedAssetItemName: bean.EntityMachine,
                IDEmployee: _single.getAccountID(),
                ReportDate: _single.getCurrenDate(),
                IsPlan: true,
                ReportTimeH: currentHour,
                ReportTimeM: currentMinute,
                State: 1,
                Observations: `Plan de mantenimientos-Maquina ${bean.EntityMachine}`,
                IDPlanMaintenanceItems: bean.IDPlanMaintenanceItems
            }).then(
                (resp) => {
                    order.instance.updateWorkMaintenanceOrder({ Observations: request.Obs, State: 0, IDItem: bean.IDFixedAssetItem, IDEmployee: _single.getAccountID(), IDRequestMaintenance: resp.IDRequestMaintenance })
                    fixedAsset.instance.setOperationalStateToFixedAssetItem(bean.IDFixedAssetItem, 34, _single.getAccountID())
                    nextMaintenance.instance.updateUpcomingMaintenanceData({
                        IDFixedAssetItem: bean.IDFixedAssetItem,
                        IDMaintenanceType: bean.IDMaintenanceTypeMachine,
                        IDEmployee: _single.getAccountID(),
                        State: 1,
                        IDPlanMaintenanceArea: _planMaintenanceArea.IDPlanMaintenanceArea,
                        ExecutionDate: _single.getCurrenDate()
                    }).then((resp) => {
                        console.log("Succes")
                    }).catch(err => toast.error("No se pudo crear Registro"))
                    modalStart.close();
                    console.log(resp);
                    editaItem({ ...bean, State: 2 });
                }
            ).catch(
                err => {
                    toast.error("No se pudo realizar la acción")
                }
            )
        }).catch(() => toast.error("No se ha podido iniciar el proceso"));

    };

    const getAlertColor = () => {
        const total = _planMaintenanceArea?.Quantity ?? 0;
        const ejecutados = info?.ExecutedCount;

        if (total === 0) return "gray";

        if (ejecutados >= total) {
            return "green";
        } else if (ejecutados < total / 2) {
            return "red";
        } else {
            return "yellow";
        }
    };

    const colorToClass: Record<string, string> = {
        green: "alert alert-success",
        yellow: "alert alert-warning",
        red: "alert alert-danger",
        gray: "alert alert-secondary",
    };

    const alertClass = colorToClass[getAlertColor()];


    return (
        <div className="row">
            {_planMaintenanceArea?.Quantity && _planMaintenanceArea.PlanState == 2 ?
                <div className="col-md-12">
                    {info?.ExecutedCount < _planMaintenanceArea?.Quantity ?
                        <Alert children={`Falta seleccionar y realizar ${_planMaintenanceArea?.Quantity && info.ExecutedCount ? (_planMaintenanceArea?.Quantity - info?.ExecutedCount) : 0} mantenimientos de ${_planMaintenanceArea?.Quantity} programados`} clase={`${alertClass}  `} />
                        :
                        <Alert children={`Mantenimeintos completados`} clase={`${alertClass}  `} />
                    }
                </div>
                :
                (null)
            }

            <div className="col-md-4">
                <label >Estado</label>
                <select className="form-select" value={data.State} onChange={((e) => {
                    const valor = e.target.value ? Number(e.target.value) : null;
                    setData({ ...data, State: valor });
                })} >
                    <option value="">...</option>
                    <option value={1}>Creado</option>
                    <option value={2}>Ejecutado</option>
                    <option value={3}>Eliminado</option>
                </select>
            </div>

            <div className="col-md-4">
                <BasicButton timeStopClickSeg={1} eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} useMargin />
            </div>

            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    listButtons={listaBotones()}
                    iconButtons={iconButtonsItem}
                    pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador}
                />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Objetivo de Mantenimiento</label>
                            <EditorFixedAssetItemByFilters filters={{ IDLocationMaintenance: _planMaintenanceArea.IDLocationMaintenance }} renderMachine={bean.FixedAssetItemCode ? `${bean.FixedAssetItemCode} - ${bean.FixedAssetDescription}` : null} idSelector={bean.IDFixedAssetItem} label="" onChange={(e) => { setBean({ ...bean, IDFixedAssetItem: e.IDItem }) }} />
                        </div>
                        <div className="col-md-12">
                            <SelectMaintenanceTypeItem idSelector={bean.IDMaintenanceTypeMachine} onChange={(e: any) => { setBean({ ...bean, IDMaintenanceTypeMachine: e?.IDMaintenanceTypeItem }); }} returnType="Object" label="Categoria" />
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea className="form-control" value={bean.Observations} onChange={(e) => { setBean({ ...bean, Observations: e.target.value }) }}  ></textarea>
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalStart.modal} updateModal={modalStart.setModal} eventModal={() => { startProcess() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <label>Justificación</label>
                            <textarea className="form-control" value={request.Obs} onChange={(e) => { setRequest({ ...request, Obs: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteItem}>
                    <strong>Eliminar mantenimiento de {bean.FixedAssetDescription}</strong>
                </ModalConfirm>
            </div >

        </div >
    )
}